export default {
  format: {
    number: {
      delimiter: ',',
    },
  },
  constants: {
    zenInfoMail: 'info@zenprotocol.com',
  },
  ui: {
    table: {
      pageSizes: [5, 10, 20, 50, 100],
      defaultPageSize: 5,
      minCellWidth: 150,
      minCellWidthDate: 200,
    },
    sizes: {
      breakpointMd: 768,
      breakpointLg: 992,
    },
  },
  loadable: {
    delay: 300,
  },
};
